import {
  get,
  post,
  put /* , upload, uploadPut, del, patch */,
  del,
  upload,
} from '@api/request';

const namespace = 'litigation';

export async function insertArbitration(
  { litigationService },
  authenticationToken,
  { payload },
) {
  const url = `${litigationService}/${namespace}/arbitrations`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchArbitrationHeaders(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/headers`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrationNotes(
  { litigationService },
  authenticationToken,
  { arbitrationID, query },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/notes${
    query ? `?${query}` : ''
  }`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateArbitrationNoteTags(
  { litigationService },
  authenticationToken,
  { noteID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/note/${noteID}/tags`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function addArbitrationNote(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/notes`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function deleteArbitrationNote(
  { litigationService },
  authenticationToken,
  { noteID },
) {
  const url = `${litigationService}/${namespace}/arbitration/note/${noteID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateArbitrationNote(
  { litigationService },
  authenticationToken,
  { noteID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/note/${noteID}`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchArbitration(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/general`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrationStatus(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/status`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateAbritrationStatus(
  { litigationService },
  authenticationToken,
  { arbitrationID, data },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/status`;
  const { body } = await put(authenticationToken, url, data);
  return body;
}

export async function updateArbitrationGeneral(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/general`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchDropdowns(
  { appraisalService },
  authenticationToken,
  { year, type, name },
) {
  let url = `${appraisalService}/appraisal/codes?type=${type}&name=${name}`;
  url += year ? `&year=${year}` : '';
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrationPresentation(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteArbitrationPresentation(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function publishArbitrationPresentation(
  { litigationService },
  authenticationToken,
  { arbitrationID, preview },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentationpublish`;
  if (!preview) {
    const { body } = await post(authenticationToken, url, { preview });
    return body;
  }

  const anchor = document.createElement('a');
  document.body.appendChild(anchor);

  const headers = new Headers();
  headers.append('Authorization', authenticationToken);
  headers.append('Content-Type', 'application/json');

  return await fetch(url, {
    headers,
    method: 'POST',
    body: JSON.stringify({ preview: 1 }),
  })
    .then((response) => response.blob())
    .then((blobby) => {
      const objectUrl = window.URL.createObjectURL(blobby);

      anchor.href = objectUrl;
      anchor.target = '_blank';
      anchor.click();
      window.URL.revokeObjectURL(objectUrl);
    });
}

export async function fetchArbitrationPresentationDocuments(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentationdocuments`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function insertArbitrationPresentationDocument(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentationdocuments`;
  const { body } = await upload(authenticationToken, url, payload);
  return body;
}

export async function deleteArbitrationPresentationDocuments(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentationdocuments`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function fetchArbitrationPresentationDocument(
  { litigationService },
  authenticationToken,
  { documentID },
) {
  const url = `${litigationService}/${namespace}/arbitration/presentationdocument/${documentID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function deleteArbitrationPresentationDocument(
  { litigationService },
  authenticationToken,
  { documentID },
) {
  const url = `${litigationService}/${namespace}/arbitration/presentationdocument/${documentID}`;
  const { body } = await del(authenticationToken, url);
  return body;
}

export async function updateArbitrationPresentationDocumentsOrder(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentationdocumentsorder`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function generateArbitrationPresentationDocument(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentationdocumentsgenerate`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchArbitrationAppraiserRecommendation(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/appraiserrecommendation`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateArbitrationAppraiserRecommendation(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/appraiserrecommendation`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function fetchArbitrationEvents(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/events/search`;
  const { body } = await post(authenticationToken, url, {
    objectID: `${arbitrationID}`,
    dataObject: 'arbitration',
  });
  return body;
}

export async function reopenArbitration(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/reopen`;
  const { body } = await put(authenticationToken, url);
  return body;
}

export async function finalizeArbitration(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/finalize`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function lockArbitration(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload = {} },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/lock`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function unlockArbitration(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/unlock`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function fetchArbitrationHearing(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/hearing`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function updateArbitrationHearing(
  { litigationService },
  authenticationToken,
  { arbitrationID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/hearing`;
  const { body } = await put(authenticationToken, url, payload);
  return body;
}

export async function fetchAvailableAgents(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/availableagents`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchAvailableOwners(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/availableowners`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function addArbitrationMarketAreaEvidence(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/addmarketareaevidence/${propertyID}`;
  const { body } = await put(authenticationToken, url, {});
  return body;
}

export async function addArbitrationCommercialEvidence(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID, payload },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/addcommercialevidence/${propertyID}`;
  const { body } = await post(authenticationToken, url, payload);
  return body;
}

export async function fetchProposedRollCorrections(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/proposedrollcorrections`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchDisposition(
  { litigationService },
  authenticationToken,
  { arbitrationID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/disposition`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPresentationAvailablePropertyComponents(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/commercialevidencepackets/availablepropertycomponents${propertyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchPresentationAvailableArtifacts(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/commercialevidencepackets/availableartifacts/${propertyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrationIncomeModels(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/commercialevidencepackets/directcapmodel/${propertyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrationIncomeActuals(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/commercialevidencepackets/directcapactuals/${propertyID}`;

  const { body } = await get(authenticationToken, url);
  return body;
}

export async function fetchArbitrationCommercialEvidenceConfig(
  { litigationService },
  authenticationToken,
  { arbitrationID, propertyID },
) {
  const url = `${litigationService}/${namespace}/arbitration/${arbitrationID}/presentation/commercialevidencepackets/configuration/${propertyID}`;
  const { body } = await get(authenticationToken, url);
  return body;
}
